import { SET_OPENED } from './actionTypes';

const initialState = {
	opened: undefined
};

const reducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_OPENED:
			return { ...state, opened: payload };
		default:
			return state;
	}
};

export default reducer;
